import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchClientInformationDataUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.clientInformation.fetchClientList;
const seacrhClientByKeywordUrl =
    CONSTANT.baseUrl +
    ENDPOINTS.employee.clientInformation.seacrhClientByKeyword;
const addNewClientUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.clientInformation.addNewClient;
const fetchAllClientInformationDataUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.clientInformation.fetchAllClient;
const fetchClientsByAccountUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.clientInformation.fetchClientsByAccount;

export const actionType = {
    REQUESTED_CLIENT_INFORMATION_DATA: 'REQUESTED_CLIENT_INFORMATION_DATA',
    REJECTED_CLIENT_INFORMATION_DATA: 'REJECTED_CLIENT_INFORMATION_DATA',
    FETCH_CLIENT_INFO: 'FETCH_CLIENT_INFO',
    SEARCH_CLIENT_BY_KEYWORD: 'SEARCH_CLIENT_BY_KEYWORD',
    ADD_NEW_CLIENT: 'ADD_NEW_CLIENT',
    EDIT_CLIENT: 'EDIT_CLIENT',
    UPDATE_CLIENT_SELECTED: 'UPDATE_CLIENT_SELECTED',
    UPDATE_SEARCH_STRING: 'UPDATE_SEARCH_STRING',
    UPDATE_ADD_NEW_CLIENT_PAYLOAD: 'UPDATE_ADD_NEW_CLIENT_PAYLOAD',
    UPDATE_EDIT_CLIENT_PAYLOAD: 'UPDATE_EDIT_CLIENT_PAYLOAD',
    FETCH_ALL_CLIENT_DATA: 'FETCH_ALL_CLIENT_DATA',
    FETCH_CLIENTS_BY_ACCOUNT: 'FETCH_CLIENTS_BY_ACCOUNT'
};

export const fetchAllClientInformationData = (allClientsOption = false) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpGetRequest(fetchAllClientInformationDataUrl, {
            allClientsOption: allClientsOption
        })
            .then(response => {
                dispatch({
                    type: actionType.FETCH_ALL_CLIENT_DATA,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
            });
    };
};

export const fetchClientInformationData = clientId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpGetRequest(fetchClientInformationDataUrl + clientId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLIENT_INFO,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
            });
    };
};

export const searchClientByKeyword = keyword => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpGetRequest(seacrhClientByKeywordUrl + keyword, null, true)
            .then(response => {
                dispatch({
                    type: actionType.SEARCH_CLIENT_BY_KEYWORD,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
            });
    };
};

export const fetchClientsByAccount = accountId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpGetRequest(fetchClientsByAccountUrl + accountId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_CLIENTS_BY_ACCOUNT,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
            });
    };
};

export const addNewClient = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpPostRequest(addNewClientUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_CLIENT,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editClient = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_CLIENT_INFORMATION_DATA
        });

        return generalHttpPutRequest(addNewClientUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_CLIENT,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_CLIENT_INFORMATION_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateClientSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_CLIENT_SELECTED,
            payload: selected
        });
    };
};

export const updateSearchString = string => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SEARCH_STRING,
            payload: string
        });
    };
};

export const updateAddNewClientPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_CLIENT_PAYLOAD,
            payload: selected
        });
    };
};

export const updateEditClientPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_CLIENT_PAYLOAD,
            payload: selected
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/clientInformation/actions.js